import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

// Link que o QR abre, com o apelido da mesa para conferir a olho. Um toque copia.
export default function LinkDaMesa({ link }) {
  const [copiado, setCopiado] = useState(false);
  if (!link) return null;

  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    } catch {
      toast.error("Copie o link manualmente.");
    }
  };

  return (
    <button
      type="button"
      onClick={copiar}
      className="mt-3 w-full flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-left hover:bg-muted transition"
      title="Copiar o link da mesa"
    >
      <span className="flex-1 min-w-0 truncate text-[11px] font-mono text-muted-foreground">
        {link.replace(/^https?:\/\//, "")}
      </span>
      {copiado ? <Check className="w-4 h-4 text-emerald-500 shrink-0" /> : <Copy className="w-4 h-4 shrink-0" />}
    </button>
  );
}
